// Module
var code = "<offer-group-detail-page\n  offer-group-id=\"$resolve.offerGroupId\"\n  variant-id=\"$resolve.variantId\"\n></offer-group-detail-page>\n";
// Exports
module.exports = code;